<template>
  <div class="short-video" ref="videoContainer">
<!--    <refresh ref="refresh" @onRefresh="onRefresh" :currentPage="currentIndex" />-->

    <md-swiper
        @before-change="beforeChange"
        :is-prevent="false"
        :is-loop="false"
        :dragable="true"
        :has-dots="false"
        :autoplay="0"
        :default-index="currentIndex"
        transition="slideY"
    >
      <md-swiper-item
          v-for="(item, index) in handleVideoList"
          :key="index"
          :data-type="type"
      >
        <!--video属性
webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
微信内置x5内核，
x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
poster：封面
src：播放地址
-->
        <!--        <iframe-->
        <!--           :src="`./video.html?url=${decrypted(item)}&videoIndex=${index}&swiperIndex=${currentIndex}&videoId=${item.id}`"-->
        <!--            frameborder="0"-->
        <!--            allow="autoplay"-->
        <!--            style="width: 100%; height: 200px;">-->
        <!--        </iframe>-->

        <video
            :ref="'videoPlayer' + type"
            :id="item.id"
            class="video-player"
            :data-type="type"
            :poster="item.cover_url"
            preload="auto"
            playsinline
            webkit-playsinline
            x5-playsinline
            x5-video-player-type="h5"
            x5-video-orientation="portrait"
            x5-video-player-fullscreen="false"
            mediatype="video"
            loop
            muted
        />

<!--        ios safati浏览器里里poster有兼容性问题， 所以用一个img来代替-->
        <img class="ios-poster"
             @click="toggleVideo"
             v-if="index === currentIndex && isShowPoster && !item.isCanplay"
             :src="item.cover_url"
        />

        <i
            class="play-icon"
            v-if="isShowPlayIcon"
            @click="toggleVideo"
        />

        <div class="left">
          <video-tips
              v-show="currentIndex === index"
              :type="type"
              :isGroup="isGroup"
              :item="item"
              @paySuccess="paySuccess"
              @onRight="onRight"
          />
          <!--  短视频标题，标签，作者名称 -->
          <short-info :item="item" />
        </div>
        <div class="right">
          <div class="avatar-wrapper">
            <img
                v-lazy="item.avatar"
                @click="goUserDetail(item.uid)"
            />
            <!-- !item.is_follow && userInfo.uid !== item.uid && !hasFollow.includes(item.uid) -->
            <i
                v-show="isFollow(item)"
                class="add-icon"
                @click="doFollow(item)"
            />
          </div>
          <div class="item-wrapper">
            <img
                v-lazy="require(`./assets/${item.is_like ? 'redLike' : 'like'}.png`)"
                class="icon"
                @click="doLike(item)"
            />
            <span>{{ item.count_awesome }}</span>
          </div>
          <div
              class="item-wrapper"
              @click="toggleComment(item)"
          >
            <img
                v-lazy="require('./assets/comment.png')"
                class="icon"
            />
            <span>{{ item.count_comment }}</span>
          </div>
          <div class="item-wrapper">
            <img
                v-lazy="require(`./assets/${item.is_collect ? 'collectActive' : 'collect'}.png`)"
                class="icon"
                @click="doCollect(item)"
            />
            <span>{{ item.count_collect }}</span>
          </div>
          <div
              class="item-wrapper"
              @click="$router.push('/invite')"
          >
            <img
                v-lazy="require('./assets/share.png')"
                class="icon"
            />
          </div>
          <div
              class="item-wrapper"
              @click="toggleMuted"
          >
            <img
                :src="mutedFlag ? require('./assets/muted.gif') : require('./assets/unMuted.gif')"
                class="icon muted-icon"
            />
            <!--            <span>{{ item.count_share }}</span>-->
          </div>
        </div>
      </md-swiper-item>
    </md-swiper>

    <div v-if="handleVideoList[currentIndex]">
      <md-slider
          v-show="type === currentType"
          ref="mdSlider"
          :id="'mdSlider' + type"
          v-model="handleVideoList[currentIndex].progress"
      />
    </div>

    <comment
        v-model="commentPopupFlag"
        :hasSearch="hasSearch"
        :vid="chooseVideo.id"
        @commentSuccess="chooseVideo.count_comment = $event"
        @share="onShare"
        v-if="commentPopupFlag"
    />

    <!--  提示弹窗 currentIndex-->
    <video-message-popup
        v-if="type === currentType"
        :show="showHomeTips"
        :count="count"
        :type="currentType"
        :isGroup="isGroup"
        :item="handleVideoList[currentIndex]"
    />
    <Share @close="showShare = false" :shareData="videoForShare" :show="showShare"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Swiper, SwiperItem, Slider } from 'mand-mobile';
import Comment from '@components/Comment';
import ShortInfo from './components/shortInfo/index.vue';
import VideoMessagePopup from '@components/VideoLimit/videoMessagePopup.vue';
import VideoTips from '@components/VideoLimit/videoTips.vue';
import {
  shortVideo,
  follow,
  collect,
  like,
  getShortHot,
  getShortHotList,
  addWatch,
  getSearch,
  getCertification,
  getIsGroup
  // shortVideoShare
} from '@api/shortVideo';
import { getShortVideos, getLikeVideos, getPrivateVideos } from '@api/userDetail';
import { decryptedMixin } from '@/mixins';
import Share from '@components/Share';
import { isIos } from '@utils';
import { transNumber } from '@utils/trans';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

// import refresh from './components/refresh/index.vue';

export default {
  name: 'ShortVideo',
  mixins: [decryptedMixin],
  props: {
    type: {
      type: String,
      default: 'home'
    },
    currentType: {
      type: String,
      default: 'home'
    },
    from: {
      type: String,
      default: null
    },
    doubleKey: {
      type: Number,
      default: 0
    }
  },
  components: {
    Share,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
    [Slider.name]: Slider,
    Comment,
    VideoMessagePopup,
    VideoTips,
    ShortInfo
    // refresh
  },
  data () {
    return {
      commentPopupFlag: false,
      hasSearch: false,
      showShare: false,
      videoForShare: {},
      params: {
        page: 1,
        page_size: 10, // 需要和ShortVideo组件的的pageSize保持一致
        nation: ''
      },
      videoList: [],
      hotVideoList: [],
      totalPageCount: 0,
      currentIndex: 0,
      isShowPlayIcon: false,
      isShowVideo: true,
      hasReqPage: [],
      chooseVideo: {},
      videoPlayer: {},
      hasFollow: [],
      progress: 0,
      mutedFlag: true,
      // loadingTimer: null,
      // loadingTimerNum: 0,
      isChangeNation: false,
      isBigProgress: false,
      isResetPage1: false,
      authVideoList: [],
      isGroup: 0, //  是否加入粉丝团：1是，2否
      count: 0, //  记录每条视频开启弹窗的次数
      playerOptions: {
        // playbackRates: [0.5, 1.0, 1.25, 1.5, 2.0, 3.0],
        // pictureInPictureToggle: true,
        autoplay: false,
        controls: false,
        preload: 'auto',
        // // fluid: true, // 自适应宽高
        muted: true, // 是否静音
        loop: true,
        controlBar: { // 设置控制条组件
          //   // 设置控制条里面组件的相关属性及显示与否
          //   // currentTimeDisplay: true,
          //   // timeDivider: true,
          //   // durationDisplay: true,
          //   // remainingTimeDisplay: true,
          //   // playbackRateMenuButton: true,
          //   // volumePanel: {
          //   //   inline: false
          //   // },
          //   /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            { name: 'playToggle' }, // 播放按钮
            { name: 'currentTimeDisplay' }, // 当前已播放时间
            { name: 'progressControl' }, // 播放进度条
            { name: 'durationDisplay' }, // 总时间
            { // 倍数播放
              name: 'playbackRateMenuButton'
            },
            {
              name: 'volumePanel', // 音量控制
              inline: false // 不使用水平方式
            },
            { name: 'pictureInPictureToggle' }, // 画中画
            { name: 'FullscreenToggle' } // 全屏
          ]
        }
      },
      hasViewIndex: [] // 已经滑到过的视频下标
    };
  },
  computed: {
    ...mapState('home', ['hasShowLaunch', 'nation']),
    ...mapState('user', ['userInfo', 'token', 'walletInfo']),
    ...mapState('publicStore', ['downloadPage', 'showHomeTips', 'loadingShowFlag']),
    ...mapState('message', ['focusList']),
    handleVideoList () {
      switch (this.type) {
        case 'hot':
          return this.hotVideoList;
        case 'authentication':
          return this.authVideoList;
        default:
          // console.log('videoList', this.videoList);
          return this.videoList;
      }
      // return this.type === 'hot' ? this.hotVideoList : this.videoList;
    },
    // reqFlag () {
    //   const length = this.videoList.length;
    //   // 还剩3条视频时开始请求下一页接口
    //   const isLeft3 = (length && length - 3) === this.currentIndex;
    //   // 没有请求过的index才允许请求
    //   const hasReqPage = !this.hasReqPage.includes(this.currentIndex);
    //   // 当前页小于总页数时才允许请求
    //   // const isLastPage = this.params.page < this.totalPageCount;
    //   // return isLeft3 && hasReqPage && isLastPage;
    //   return isLeft3 && hasReqPage;
    // }
    currentVideoPlayer () {
      return this.videoPlayer[this.type][this.currentIndex];
    },
    isShowPoster () {
      return isIos();
      // return isIos() && !this.isWebClip;
    }
  },
  watch: {
    '$route.path': {
      handler (val, valOld) {
        if (!['/home'].includes(val)) {
          this.currentVideoPlayer && this.stop(this.currentVideoPlayer);
        }
      }
    },
    doubleKey () {
      this.onRefresh();
    },
    currentType (val) {
      // console.log('this.hotVideoList.length', this.hotVideoList.length, this.hotVideoList);
      if (val === 'hot' && this.type === val && !this.hotVideoList.length) {
        this.setTypeFetch(val);
      }

      if (val === 'authentication' && this.type === val && !this.authVideoList.length) {
        this.setTypeFetch(val);
      }

      if (val === 'home' && this.type === val && !this.videoList.length) {
        this.setTypeFetch(val);
      }

      if (this.currentVideoPlayer) {
        this.stop(this.currentVideoPlayer);

        if (this.videoPlayer[this.currentType] && this.videoPlayer[this.currentType].length && this.videoPlayer[this.currentType][this.currentIndex]) {
          // this.videoPlayer[this.currentType].autoplay = true;
          this.videoPlayer[this.currentType][this.currentIndex].play && this.videoPlayer[this.currentType][this.currentIndex].play();
          this.isShowPlayIcon = false;
        }
      }
    },
    hasShowLaunch: {
      handler (val) {
        if (val) {
          this.setVideoPlayer(0);

          if (this.type === this.currentType) {
            this.videoAutoPlay(0);
          }
          this.bindStopVideo();
        }
      }
    },
    token: {
      handler () {
        this.currentVideoPlayer && this.stop(this.currentVideoPlayer);
        this.hasViewIndex = [];
        this.currentIndex = 0;
        this.params.page = 1;
        this.hotVideoList = [];
        this.authVideoList = [];
        this.videoList = [];
        this.$set(this.videoPlayer, this.type, []);

        if (this.type === this.currentType) {
          this.setTypeFetch(this.currentType);
        }
      }
      // immediate: true
    }
  },
  activated () {
    console.log('activated');
    //  如果用户进入作者主页，在回退回来，要查看用户是否加入粉丝团了
    if (this.currentType === 'authentication' &&
        (this.authVideoList.length && this.authVideoList[this.currentIndex] && this.authVideoList[this.currentIndex].id
        )) {
      this.fetchIsGroup(this.authVideoList[this.currentIndex].id);
    }
    // 在首次挂载、
    // 以及每次从缓存中被重新插入的时候调用
    // this.hasFollow = [];
    this.$nextTick(() => {
      this.setVideoPlayer(this.currentIndex);
      if (this.type === this.currentType) {
        this.videoAutoPlay(this.currentIndex);
      }
      this.bindStopVideo();
    });
    this.isShowPlayIcon = false;
  },
  deactivated () {
    // 在从 DOM 上移除、进入缓存
    // 以及组件卸载时调用
    this.currentVideoPlayer && this.stop(this.currentVideoPlayer);
    clearInterval(this.loadingTimer);
    this.loadingTimer = null;
    this.loadingTimerNum = 0;
    this.$toast.hide();
    this.setShowHomeTips(false);
  },
  mounted () {
    this.$set(this.videoPlayer, this.type, []);
    this.initFetch();
  },
  beforeDestroy () {
    this.currentVideoPlayer && this.stop(this.currentVideoPlayer);
    clearInterval(this.loadingTimer);
    this.loadingTimer = null;
    this.loadingTimerNum = 0;
    this.$toast.hide();
  },
  methods: {
    ...mapActions('publicStore', ['addShortTask']),
    ...mapMutations('publicStore', ['setLoadingShowFlag', 'setShowHomeTips', 'setIsHomeShowSkeleton']),
    ...mapActions('user', ['getWalletInfo']),
    ...mapActions('message', ['getFocusList']),
    initFetch (loadType = 'default') {
      // 这版本不做多语言，暂时注释
      /*      if (this.type === 'hot') {
        this.$bus.$off('setHotVideoList');
        this.$bus.$on('setHotVideoList', () => {
          this.params.page = 1;
          this.currentIndex = 0;
          this.hotVideoList = [];
          this.isChangeNation = true;
          this.isShowPlayIcon = false;
        });
      } else if (this.type === 'home') {
        this.$bus.$off('setVideoList');
        this.$bus.$on('setVideoList', () => {
          this.params.page = 1;
          this.currentIndex = 0;
          this.videoList = [];
          this.isChangeNation = true;
          this.isShowPlayIcon = false;
        });
      } else if (this.type === 'authentication') {
        this.$bus.$off('setVideoList');
        this.$bus.$on('setVideoList', () => {
          this.params.page = 1;
          this.currentIndex = 0;
          this.authVideoList = [];
          this.isChangeNation = true;
          this.isShowPlayIcon = false;
        });
      } */
      if (this.from === 'userDetail') {
        const userVideoObj = localStorage.getItem('userVideoObj') && JSON.parse(localStorage.getItem('userVideoObj'));
        if (userVideoObj) {
          userVideoObj.videoList.forEach(item => {
            const hasProgress = 'progress' in item;
            if (!hasProgress) {
              item.progress = 0;
            }
          });
          this.videoList = userVideoObj.videoList;
          this.params.page = userVideoObj.page;
          this.totalPageCount = userVideoObj.totalPageCount;
          this.currentIndex = userVideoObj.videoIndex;
          const videoObj = this.videoList[this.currentIndex];

          if (videoObj) {
            // console.log('videoObj', videoObj);
            //  如果从个人主页入口进来观看视频，还是要在调一下是否加入了粉丝团接口
            if (videoObj.is_public === 3) {
              this.fetchIsGroup(videoObj.id);
            } else {
              // this.fetchAddVipVideo(videoObj.id);
            }
          }
          this.$nextTick(() => {
            if (this.$route.path === '/userShortVideo') {
              this.setAutoAndPlay(this.currentIndex);
              this.binProgressEvent();
              this.bindStopVideo();
            }
          });
        } else {
          this.$router.push('/home');
        }
      } else {
        if (this.currentType === 'hot' && this.type === this.currentType) {
          this.getHotShortVideo(loadType);
          //  绑定切换语言后要调用的接口
          // this.initAfterChangeLang([this.getHotShortVideo]);
        } else if (this.currentType === 'home' && this.type === this.currentType) {
          this.getShortVideo();
          //  绑定切换语言后要调用的接口
          // this.initAfterChangeLang([this.getShortVideo]);
        } else if (this.currentType === 'authentication' && this.type === this.currentType) {
          this.fetchAuthShortVideo(loadType);
        }
      }
      if (this.$route.query.comment) {
        this.toggleComment(this.videoList[this.currentIndex]);
      }
    },
    fetchWallet () {
      if (this.token) {
        this.getWalletInfo();
        this.getFocusList();
      }
    },
    getShortVideo () {
      let api = shortVideo;
      // if (this.type === 'hot') {
      //   api = getShortHot;
      // } else

      const uid = this.$route.query.uid;
      if (this.type === 'shortHotList') {
        // 热榜短视频
        api = getShortHotList;
      } else if (this.type === 'production') {
        api = getShortVideos;
        this.params.uid = uid;
      } else if (this.type === 'like') {
        api = getLikeVideos;
        this.params.uid = uid;
      } else if (this.type === 'private') {
        api = getPrivateVideos;
        this.params.uid = uid;
      } else if (this.type === 'searchResult') {
        api = getSearch;
        this.params.content = this.$route.query.searchText;
      }
      this.params.nation = this.nation;
      this.hasReqPage.push(this.currentIndex);

      api(this.params).then(res => {
        if (res.result === 200000) {
          this.setIsHomeShowSkeleton(false);
          const list = res.data.list.list;
          list.forEach(item => {
            const hasProgress = 'progress' in item;
            if (!hasProgress) {
              item.progress = 0;
            }
            this.$set(item, 'isCanplay', false);
          });

          this.videoList = this.videoList.concat(list);
          this.$nextTick(() => {
            const path = this.$route.path;
            if (this.params.page === 1 && (path !== '/home' || this.isChangeNation || this.hasShowLaunch) && !this.isResetPage1) {
              this.setAutoAndPlay(0);
              this.bindStopVideo();
              this.isChangeNation = false;
              this.isResetPage1 = false;
            }
            this.setVideoIsMuted(true);
            this.binProgressEvent();
          });

          this.totalPageCount = res.data.list.pageCount;
          if (this.videoList.length && this.params.page === 1) {
            this.addWatch(this.videoList[0].id);
            //  付费请求
            // if (this.videoList[0].is_money === 1) {
            //   this.fetchAddVipVideo(this.videoList[0].id);
            // }
            // this.addShortTask({ vid: this.videoList[0].id, type: 1 });
          }

          // setTimeout(() => {
          //   this.$refs.refresh.finishRefresh();
          // }, 1000);
        }
      });
    },
    //  热们短视频
    getHotShortVideo (loadType = 'default') {
      // 修复切换地区时出现的bug，所有单独把热门短视频请求独立开来
      this.params.nation = this.nation;
      this.hasReqPage.push(this.currentIndex);
      getShortHot(this.params).then(res => {
        if (res.result === 200000) {
          const list = res.data.list.list;
          list.forEach(item => {
            const hasProgress = 'progress' in item;
            if (!hasProgress) {
              item.progress = 0;
            }
            this.$set(item, 'isCanplay', false);
          });
          this.hotVideoList = this.hotVideoList.concat(list);

          this.$nextTick(() => {
            const path = this.$route.path;
            if (this.params.page === 1 && (path !== '/home' || this.isChangeNation || this.hasShowLaunch) && !this.isResetPage1) {
              this.setAutoAndPlay(0);
              // this.setVideoPlayer(0);
              this.bindStopVideo();
              this.isChangeNation = false;
              this.isResetPage1 = false;
            }
            this.setVideoIsMuted(true);
            this.binProgressEvent();
          });
          this.totalPageCount = res.data.list.pageCount;
          if ((this.hotVideoList.length && this.params.page === 1) || loadType === 'refresh') {
            this.addWatch(this.hotVideoList[0].id);
            //  付费请求
            // if (this.hotVideoList[0].is_money) {
            //   this.fetchAddVipVideo(this.hotVideoList[0].id);
            // }
            // this.addShortTask({ vid: this.hotVideoList[0].id, type: 1 });
          }
          // setTimeout(() => {
          //   this.$refs.refresh.finishRefresh();
          // }, 1000);
        }
      });
    },
    //  认证短视频列表
    fetchAuthShortVideo (loadType = 'default') {
      getCertification(this.params).then(res => {
        if (res.result === 200000) {
          const list = res.data.list.list;
          list.forEach(item => {
            const hasProgress = 'progress' in item;
            if (!hasProgress) {
              item.progress = 0;
            }
            this.$set(item, 'isCanplay', false);
          });
          this.authVideoList = this.authVideoList.concat(list);
          this.$nextTick(() => {
            const path = this.$route.path;
            if (this.params.page === 1 && (path !== '/home' || this.isChangeNation || this.hasShowLaunch) && !this.isResetPage1) {
              this.setAutoAndPlay(0);
              // this.setVideoPlayer(0);
              this.bindStopVideo();
              this.isChangeNation = false;
              this.isResetPage1 = false;
            }
            this.setVideoIsMuted(true);
            this.binProgressEvent();
          });
          this.totalPageCount = res.data.list.pageCount;
          if ((this.authVideoList.length && this.params.page === 1) || loadType === 'refresh') {
            this.addWatch(this.authVideoList[0].id);
            this.fetchIsGroup(this.authVideoList[0].id);
            // this.addShortTask({ vid: this.authVideoList[0].id, type: 1 });
          }

          // setTimeout(() => {
          //   this.$refs.refresh.finishRefresh();
          // }, 1000);
        }
      });
    },
    //  用户是否加入了粉丝团
    fetchIsGroup (id) {
      if (this.token) {
        getIsGroup({ id }).then(res => {
          if (res.result === 200000) {
            this.isGroup = res.data.list.is_group;
          }
        });
      }
    },
    //  解锁会员权益
    onRight (free) {
      let list = [];
      switch (this.type) {
        case 'hot':
          list = this.hotVideoList;
          break;
        case 'authentication':
          list = this.authVideoList;
          break;
        default:
          list = this.videoList;
          break;
      }

      this.setVideoList(!free ? 3 : 1, list);
    },
    //  短视频支付成功
    paySuccess () {
      const isPublic = 'is_public' in this.handleVideoList[this.currentIndex] ? this.handleVideoList[this.currentIndex].is_public : 1;
      if (this.currentType === 'authentication' || isPublic === 3) {
        // this.fetchIsGroup(this.videoPlayer.id);
        this.setVideoList(3, this.authVideoList);
      } else if (this.currentType === 'hot' || isPublic === 2) {
        this.setVideoList(3, this.hotVideoList);
      } else {
        this.setVideoList(3, this.videoList);
      }
    },
    setVideoList (isMoney, arr) {
      this.$set(arr, this.currentIndex, {
        ...arr[this.currentIndex],
        is_money: isMoney
      });
      console.log('视频列表', arr);
    },
    setTypeFetch (type) {
      /*      if (this.currentVideoPlayer) {
        this.currentVideoPlayer.currentTime = 0;
      } */
      this.fetchWallet();
      switch (type) {
        case 'hot':
          return this.getHotShortVideo();
        case 'authentication':
          return this.fetchAuthShortVideo();
        case 'home':
          return this.getShortVideo();
      }
      // if (this.$route.path === '/home') {
      //   switch (type) {
      //     case 'hot':
      //       return this.getHotShortVideo();
      //     case 'authentication':
      //       return this.fetchAuthShortVideo();
      //     case 'home':
      //       return this.getShortVideo();
      //   }
      // }
    },
    addWatch (vid) {
      addWatch({ vid: String(vid) });
    },
    toggleComment (item) {
      if (this.userInfo.token) {
        this.chooseVideo = item;
        this.commentPopupFlag = !this.commentPopupFlag;
      } else {
        this.$router.push('/login');
      }
    },
    beforeChange (from, to) {
      this.setLoadingShowFlag(false); // 关掉加载中动画

      this.currentIndex = to;

      // const currentPlayer = this.$refs['videoPlayer' + this.type][from];
      // currentPlayer.autoplay = false;

      const currentPlayer = this.videoPlayer[this.type][from];
      // currentPlayer.autoplay = false;

      this.count = 0;
      if (this.showHomeTips) {
        this.setShowHomeTips(false);
      }

      this.stop(currentPlayer);

      this.isShowPlayIcon = false;
      // const nextPlayer = document.getElementsByClassName('md-swiper-item')[to].getElementsByTagName('video')[0];

      this.setAutoAndPlay(to);

      // 保存已经滑到过的视频下标， 必须载this.setAutoAndPlay之后保存
      if (!this.hasViewIndex.includes(to)) {
        this.hasViewIndex.push(to);
      }
      // this.videoPlayer.autoplay = true;
      // this.videoPlayer.play();
      this.addWatch(this.handleVideoList[to].id);
      //  只有认证视频请求这个接口
      if (this.currentType === 'authentication') {
        this.fetchIsGroup(this.handleVideoList[to].id);
      } else {
        // this.fetchAddVipVideo(this.currentVideoPlayer.id);
      }
      // this.addShortTask({ vid: this.videoPlayer.id, type: 1 });

      // 还剩3条视频时开始请求下一页接口
      const length = this.handleVideoList.length;
      const isLeft3 = (length && length - 3) === this.currentIndex;
      // 没有请求过的index才允许请求
      const hasReqPage = !this.hasReqPage.includes(this.currentIndex);

      if (from < to) {
        if ((this.params.page >= this.totalPageCount) && (this.currentIndex === (length - 1))) {
          this.params.page = 1;
          this.isResetPage1 = true;
          // if (this.type === 'hot') {
          //   this.getHotShortVideo();
          // } else if (this.type === 'authentication') {
          //   this.fetchAuthShortVideo();
          // } else {
          //   this.getShortVideo();
          // }
          this.setTypeFetch(this.currentType);
        } else if (this.params.page < this.totalPageCount && isLeft3 && hasReqPage) {
          this.params.page++;
          // if (this.type === 'hot') {
          //   this.getHotShortVideo();
          // } else if (this.type === 'authentication') {
          //   this.fetchAuthShortVideo();
          // } else {
          //   this.getShortVideo();
          // }
          this.setTypeFetch(this.currentType);
        }
      }
    },
    toggleVideo () {
      if (this.currentVideoPlayer.paused()) {
        this.currentVideoPlayer.play();
        this.isShowPlayIcon = false;
      } else {
        this.currentVideoPlayer.pause();
        this.isShowPlayIcon = true;
        this.setLoadingShowFlag(false);
      }
    },
    doLike (item) {
      // 如果是自己的视频并且已经审核通过 正常逻辑
      // 如果不是自己的视频 正常逻辑
      if (((item.uid === this.userInfo.uid && item.is_audit === 2) ||
              (item.uid !== this.userInfo.uid)) &&
          (item.status === 1 || item.status === undefined)) {
        // status 1点赞 ， 2取消点赞
        let status = '';
        if (item.is_like === 1) {
          item.is_like = 0;
          status = 2;
          item.count_awesome--;
        } else if (item.is_like === 0) {
          item.is_like = 1;
          status = 1;
          item.count_awesome++;
        }
        like({ vid: item.id, status }).then(res => {
        });
      } else {
        const status = item.is_like === 1 ? 2 : 1;
        like({ vid: item.id, status }).then(res => {
          this.$toast.failed(res.msg);
        });
      }
    },
    doFollow (item) {
      // this.hasFollow.push(item.uid);
      follow({ uid: item.uid }).then(res => {
        if (res.result === 200000) {
          item.is_follow = 1;
          this.getFocusList();
        }
      });
    },
    doCollect (item) {
      // 如果是自己的视频并且已经审核通过 正常逻辑
      // 如果不是自己的视频 正常逻辑
      if (((item.uid === this.userInfo.uid && item.is_audit === 2) ||
              (item.uid !== this.userInfo.uid)) &&
          (item.status === 1 || item.status === undefined)) {
        // status 1收藏 ， 2取消收藏
        let status = item.is_collect === 1 ? 0 : 1;
        if (item.is_collect === 1) {
          item.is_collect = 0;
          status = 2;
          item.count_collect--;
        } else if (item.is_collect === 0) {
          item.is_collect = 1;
          status = 1;
          item.count_collect++;
        }
        collect({ vid: item.id, status }).then(res => {
        });
      } else {
        const status = item.is_collect === 1 ? 0 : 1;
        collect({ vid: item.id, status }).then(res => {
          this.$toast.failed(res.msg);
        });
      }
    },
    goUserDetail (uid) {
      localStorage.setItem('fromRoute', this.$route.fullPath);
      if (this.userInfo.uid !== uid) {
        this.$router.push({ path: '/userDetail', query: { uid } });
      } else {
        this.$router.push({ path: '/mine' });
      }
    },
    stop (videoPlayer) {
      videoPlayer && videoPlayer.pause && videoPlayer.pause();
    },
    ifMountedVideo (index) {
      // 只有在这个区间内的video标签才给src赋值
      // return index <= this.currentIndex + 6 && index >= this.currentIndex - 3;
      return this.currentIndex + 1 >= index;
    },
    setVideoPlayer (index) {
      console.log('setVideoPlayer--index', index);
      const videoPlayer = this.$refs['videoPlayer' + this.type];
      const dom = videoPlayer && videoPlayer.length && videoPlayer[index];

      if (dom && !this.videoPlayer[this.type][index]) {
        const player = videojs(dom, this.playerOptions, () => {
          // this.player.log('onPlayerReady', this);
        });
        this.$set(this.videoPlayer[this.type], index, player);

        console.log('videoPlayer', this.videoPlayer);

        //  监听事件
        this.currentVideoPlayer.ready(() => {
          this.currentVideoPlayer.on('canplay', () => {
            this.$set(this.handleVideoList[index], 'isCanplay', true);
          });

          this.currentVideoPlayer.on('timeupdate', () => {
            this.setProgress(this.handleVideoList[this.currentIndex]);
          });

          this.currentVideoPlayer.on('playing', () => {
            this.playing(this.currentIndex);
          });

          this.currentVideoPlayer.on('waiting', () => {
            this.waiting(this.currentIndex);
          });

          this.currentVideoPlayer.on('error', () => {
            const src = this.currentVideoPlayer.currentSrc();

            this.currentVideoPlayer.pause();
            if (!src.includes('mp4') || !src.includes('MP4')) {
              this.playMp4Video();
            }
          });

          this.currentVideoPlayer.on('waiting', () => {
            this.waiting(this.currentIndex);
          });

          let startTime = 0;
          let startX = 0;
          let startY = 0;

          // 点击事件， 直接监听click事件不生效，所以得自己实现
          // 1.时间间隔：小于 300ms（通常 150ms ~ 250ms ）
          // 2.触点移动距离：小于 10px

          this.currentVideoPlayer.el().addEventListener('touchstart', (e) => {
            startTime = Date.now();
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
          });

          this.currentVideoPlayer.el().addEventListener('touchend', (e) => {
            const endTime = Date.now();
            const touch = e.changedTouches[0];
            const deltaX = Math.abs(touch.clientX - startX);
            const deltaY = Math.abs(touch.clientY - startY);

            if (endTime - startTime < 300 && deltaX < 10 && deltaY < 10) {
              console.log('点击事件');
              this.toggleVideo();
            }
          });
        });
      }
    },
    playMp4Video () {
      this.$nextTick(() => {
        const data = {
          src: this.decrypted(this.handleVideoList[this.currentIndex].url),
          type: 'video/mp4'
        };
        // this.currentVideoPlayer.pause();
        this.currentVideoPlayer.src(data);
        // this.currentVideoPlayer.load(data);
        this.currentVideoPlayer.play();
      });
    },
    videoAutoPlay (index) {
      console.log('hasViewIndex', this.hasViewIndex);
      console.log('handleVideoList', this.handleVideoList);

      if (!this.hasViewIndex.includes(index) && this.handleVideoList[index]) {
        // 没看过的才设置src和type， 防止已经加载过的视频重新加载
        const m3u8Url = this.handleVideoList[index].m3u8_url;

        let data = {
          src: this.decrypted(m3u8Url),
          type: 'application/x-mpegURL'
        };

        if (!m3u8Url) {
          data = {
            src: this.decrypted(this.handleVideoList[this.currentIndex].url),
            type: 'video/mp4'
          };
        }
        // console.log('url', url);
        // this.currentVideoPlayer.pause();
        this.currentVideoPlayer.src(data);
      }

      if (this.handleVideoList[index]) {
        // this.currentVideoPlayer.load(data);
        // 推荐tab的视频在用户没有和页面做交互的时候， 第一个视频要自动播放， 所以需要静音， 其他视频取消静音
        if (index !== 0 || this.type !== 'home') {
          this.currentVideoPlayer.muted(false);
          this.mutedFlag = false;
        }
        this.currentVideoPlayer.play();
      }
    },
    setAutoAndPlay (index) {
      this.setVideoPlayer(index);
      // if (this.$route.path === '/home' && this.type === this.currentType) {
      //   this.videoAutoPlay(index);
      // }
      this.videoAutoPlay(index);
    },
    share (item) {
      if ((Number(item.is_audit) !== 2 || Number(item.status) !== 1) && item.status !== undefined) {
        return this.$toast.failed(this.$t('shareFailByNotAudit'));
      }
      this.showShare = true;
      // 对短视频Url进行解密
      // const _item = JSON.parse(JSON.stringify(item));
      // _item.url = this.decrypted(_item);
      // _item.is_encrypt = 0;
      this.videoForShare = {
        type: 1007,
        data: {
          type: 'shortVideo',
          obj: JSON.stringify(item)
        }
      };
      // shortVideoShare({ vid: item.id });
      // this.doCopy(item.url);
      // window.open(this.downloadPage);
    },
    setProgress (item) {
      // this.progress = (this.videoPlayer.currentTime / this.videoPlayer.duration) * 100;
      const currentTime = this.currentVideoPlayer.currentTime() ? this.currentVideoPlayer.currentTime() : 0;
      const duration = this.currentVideoPlayer.duration() ? this.currentVideoPlayer.duration() : 0;
      //  达到预览时长暂停播放
      const { isLimit, isProgress } = this.setCurrentMovieLimit(item);
      // 判断是否达到预览时长并暂停播放
      const d = isProgress && item.play_time > 0 ? item.play_time : duration;
      item.progress = (currentTime / d) * 100;
      const fixedTime = transNumber(currentTime.toFixed(0));
      if (isProgress && item.play_time > 0 && fixedTime >= item.play_time) {
        this.currentVideoPlayer.currentTime(0);

        //  用户余额小于金币数量 && 金币数量大于0，才开启窗口
        if (!this.showHomeTips && !this.count && isLimit) {
          this.setShowHomeTips(true);
          this.count++;
        }
      }
    },
    //  设置观影限制
    /**
     * @param item 当前播放的视频
     * @returns {{isLimit: boolean, isProgress: boolean}}
     * isLimit: 弹窗限制，isProgress： 进度条限制
     */
    setCurrentMovieLimit (item) {
      // 不限制
      // console.log('item.uid', item.uid, transNumber(this.userInfo.uid));
      const userUid = transNumber(this.userInfo.uid);
      if (item.uid === userUid) {
        return { isLimit: false, isProgress: false };
      }
      //  是否是付费视频,1:是，2:不是
      const isMoney = 'is_money' in item ? item.is_money : 0;
      const isVip = 'is_vip' in item ? item.is_vip : 0;
      const isPublic = item.is_public ? item.is_public : 1;
      const isAuth = isPublic === 3 || this.currentType === 'authentication';
      // 付费视频的金币数量
      const money = 'money' in item ? transNumber(item.money) : 0;
      //  用户余额
      const balance = transNumber(this.walletInfo.balance);
      if (isAuth) {
        if (this.isGroup === 1 || isMoney === 3) {
          return { isLimit: false, isProgress: false };
        }
        if (this.isGroup === 2) {
          if (isMoney === 1) {
            return balance < money ? { isLimit: true, isProgress: true } : { isLimit: false, isProgress: true };
          }
          return { isLimit: true, isProgress: true };
        }
      } else {
        //  付费视频并且不是VIP：isMoney === 1,查看用户是否有免费观看的权限，true：没有，false: 有
        if (isMoney === 1 && isVip !== 1) {
          const videoCount = transNumber(this.userInfo.video_count);
          //  付费视频，vip用户手动解锁，暂时还要封锁起来
          if (videoCount > 0) {
            return { isLimit: false, isProgress: true };
          }
          const isTrue = balance < money;
          return { isLimit: isTrue, isProgress: true };
        } else if (isVip === 1 && isMoney !== 1) {
          return { isLimit: this.userInfo.is_vip !== 1, isProgress: this.userInfo.is_vip !== 1 };
        } else {
          return { isLimit: false, isProgress: false };
        }
      }
    },
    //  设置视频播放的进度
    progressChange () {
      this.currentVideoPlayer.currentTime((this.progress / 100) * this.currentVideoPlayer.duration());
    },
    binProgressEvent () {
      const mdSlider = document.getElementById('mdSlider' + this.type);

      if (mdSlider) {
        mdSlider.getElementsByClassName('md-slider-handle')[0]
          .getElementsByTagName('span')[0].addEventListener('touchmove', () => {
            this.progressChange();
          });

        mdSlider.getElementsByClassName('md-slider-handle')[0]
          .getElementsByTagName('span')[0].addEventListener('touchmove', () => {
            this.isBigProgress = true;
          });
        mdSlider.getElementsByClassName('md-slider-handle')[0]
          .getElementsByTagName('span')[0].addEventListener('touchend', () => {
            this.isBigProgress = false;
          });

        mdSlider.addEventListener('touchstart', () => {
          this.isBigProgress = true;
        });

        mdSlider.addEventListener('touchend', () => {
          this.isBigProgress = false;
        });

        mdSlider.addEventListener('touchmove', (e) => {
          this.progress = (e.targetTouches[0].clientX / mdSlider.offsetWidth) * 100;
          this.progressChange();
        });

        mdSlider.getElementsByClassName('md-slider-bar')[0].addEventListener('touchmove', (e) => {
          this.progress = (e.targetTouches[0].clientX / mdSlider.offsetWidth) * 100;
          this.progressChange();
        });
      }
    },
    bindStopVideo () {
      this.$bus.$off('stopVideo');
      this.$bus.$on('stopVideo', () => {
        if (!this.currentVideoPlayer.paused()) {
          this.currentVideoPlayer.pause();
          this.isShowPlayIcon = true;
        }
      });
    },
    toggleMuted () {
      this.mutedFlag = !this.mutedFlag;
      this.setVideoIsMuted();
    },
    setVideoIsMuted (isFetch) {
      /*      if (isIos() && isFetch) {
        // ios的浏览器每次获取接口后都需要将视频设置为静音才能自动播放
        this.mutedFlag = true;
      } */

      this.videoPlayer[this.type].forEach(item => {
        item.muted(this.mutedFlag);
      });
    },
    playing (index) {
      if (this.currentIndex === index) {
        this.setLoadingShowFlag(false);
        /*        clearInterval(this.loadingTimer);
        this.loadingTimerNum = 0;
        this.loadingTimer = null;
        this.$toast.hide(); */
      }
    },
    waiting (index) {
      if (this.currentIndex === index) {
        if (!this.currentVideoPlayer.paused()) {
          this.setLoadingShowFlag(true);
        }
        // clearInterval(this.loadingTimer);
        // this.loadingTimer = null;
        /*        this.loadingTimer = setInterval(() => {
          if (this.loadingTimerNum > 9) {
            clearInterval(this.loadingTimer);
            this.loadingTimer = null;
            // this.$toast.failed(this.$t('networkAnomaly'), 0);
          } else {
            this.loadingTimerNum++;
          }
        }, 1000); */
      }
    },
    /*    onCanPlay (item) {
      item.isCanplay = true;
    }, */
    onShare () {
      this.commentPopupFlag = false;
    },
    //  用户是否关注了作者
    isFollow (item) {
      if (item.uid === this.userInfo.uid) {
        return false;
      } else {
        const hasFollow = this.focusList.some(f => f.id === item.uid);
        return !item.is_follow || !hasFollow;
      }
    },
    onRefresh () {
      this.currentVideoPlayer && this.stop(this.currentVideoPlayer);
      this.isShowPlayIcon = false;

      if (this.currentType === 'hot') {
        this.hotVideoList = [];
      } else if (this.currentType === 'authentication') {
        this.authVideoList = [];
      } else {
        this.videoList = [];
      }
      if (this.currentVideoPlayer) {
        this.currentVideoPlayer.currentTime(0);
      }
      // const hasReqPage = !this.hasReqPage.includes(this.currentIndex);
      if (this.params.page < this.totalPageCount && ['hot', 'authentication'].includes(this.currentType)) {
        this.params.page++;
      } else if (this.params.page >= this.totalPageCount) {
        this.params.page = 1;
      }
      this.initFetch('refresh');
    }
  }
};
</script>

<style lang="scss" scoped>
.short-video {
  position: relative;
  height: 100%;
  //background-image: url("./assets/devImg/balanceBg.png");
  //background-size: 100% 100%;

  /deep/ .md-swiper-container {
    height: 100%!important;
  }

  /deep/ .md-swiper-item {
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 100%!important;
  }

  /deep/ .video-player {
    position: relative;
    width: 100%!important;
    z-index: 1;

    &[class*="dimensions"] {
      height: unset!important;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .vjs-loading-spinner {
      display: none;
    }
  }

  .ios-poster {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: 100%;
  }

  .play-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 3;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    background: url("~@assets/imgs/public/playIcon.png") 0 0/100% 100%;
  }

  .left {
    position: absolute;
    left: 11px;
    bottom: 31px;
    z-index: 4;
    //.labels {
    //  display: flex;
    //  align-items: center;
    //  flex-wrap: wrap;
    //  width: 295px;
    //  margin-bottom: 15px;
    //
    //  .label {
    //    height: 22px;
    //    padding: 0 12px;
    //    margin-right: 5.5px;
    //    margin-bottom: 4px;
    //    background: rgba(28, 28, 28, 0.35);
    //    border-radius: 24px;
    //    font-family: 'PingFang SC';
    //    font-size: 11px;
    //    line-height: 22px;
    //    color: #FFFFFF;
    //  }
    //}

    .title {
      width: 295px;
      margin-bottom: 15px;
      font-family: 'PingFang SC';
      font-size: 14px;
      line-height: 18px;
      color: #FFFFFF;
    }

    .describe {
      width: 295px;
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #FFFFFF;
    }
  }

  .right {
    position: absolute;
    right: 4px;
    bottom: 31px;
    z-index: 4;
    width: 50px;

    .avatar-wrapper {
      position: relative;
      margin-bottom: 28px;
      width: 48px;

      img {
        position: relative;
        z-index: 1;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #000;
      }

      i {
        position: absolute;
        left: 50%;
        bottom: -18px;
        z-index: 2;
        transform: translateX(-50%);
        width: 24px;
        height: 24px;
        background: url("assets/folloIcon.png") 0 0/100% 100%;
      }
    }

    .item-wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-bottom: 16px;

      img {
        width: 32px;
        height: 32px;
        margin-bottom: 6px;

        &.muted-icon {
          width: 58px;
          height: 58px;
        }
      }

      span {
        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 14px;
        line-height: 12px;
        color: #FFFFFF;
      }
    }
  }

  /deep/ .md-slider {
    //position: fixed;
    bottom: -1px;
    height: 6px;
    z-index: 10000;
    position: absolute;

    &:before {
      top: 50%;
      transform: translateY(-50%);
      height: 6px;
      background: #555555;
    }

    .md-slider-bar {
      top: 50%;
      transform: translateY(-50%);
      height: 6px;
      background-color: #FFF;
    }

    .md-slider-handle {
      z-index: 10000;
      top: 50%;
      transform: translateY(-50%);
      margin-left: -7.5px;

      span {
        width: 6.4px;
        height: 6.4px;
      }
    }

    &.isBigProgress {
      height: 20px;

      &:before {
        height: 20px;
      }

      .md-slider-bar {
        height: 20px;
        opacity: 0.97;
      }

      .md-slider-handle {
        z-index: 10000;
        top: 50%;
        transform: translateY(-50%);
        margin-left: -2px;

        span {
          width: 4px;
          height: 24px;
          border-radius: 6px;
        }
      }
    }
  }

  .loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000000000;
    width: 40px;
    height: 40px;
  }
}
</style>
